import mistreatmentContext from '@/contexts/mistreatmentContext'
import mistreatmentReducer, { INITIAL_STATE } from '@/reducers/mistreatment'
import List from '@/views/app/Mistreatments'
import Status from '@/views/app/Mistreatments/Status'
import Show from '@/views/app/Mistreatments/Show'
import Form from '@/views/app/Mistreatments/Form'
import Cancel from '@/views/app/Mistreatments/Show/Cancel'
import Done from '@/views/app/Mistreatments/Show/Done'
import Reject from '@/views/app/Mistreatments/Show/Reject'
import StartCheck from '@/views/app/Mistreatments/Show/StartCheck'
import React, { useReducer } from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import OpenOsm from '@/views/app/Mistreatments/Show/OpenOsm'

function MistreatmentsRoutes() {
  const { path } = useRouteMatch()
  const [state, dispatch] = useReducer(mistreatmentReducer, INITIAL_STATE)

  return (
    <div>
      <Route path={path} exact>
        <List title="Petis - Parceiros / Denúncias de maus tratos" />
      </Route>
      <Route exact path={`${path}/status/:status`}>
        <Status title="Petis - Parceiros / Denúncias de maus tratos / Lista" />
      </Route>
      <mistreatmentContext.Provider value={{ state, dispatch }}>
        <Route exact path={`${path}/form/add`}>
          <Form title="Petis - Parceiros / Denúncias de maus tratos / Nova denúncia" />
        </Route>
        <Route path={`${path}/status/:status/show/:id`}>
          <Show title="Petis - Parceiros / Denúncias de maus tratos / Denúncia" />
        </Route>
        <Route path={`${path}/status/:status/show/:id/start-check`}>
          <StartCheck title="Petis - Parceiros / Denúncias de maus tratos / Denúncia / Iniciar verificação" />
        </Route>
        <Route path={`${path}/status/:status/show/:id/cancel`}>
          <Cancel title="Petis - Parceiros / Denúncias de maus tratos / Denúncia / Cancelar" />
        </Route>
        <Route path={`${path}/status/:status/show/:id/reject`}>
          <Reject title="Petis - Parceiros / Denúncias de maus tratos / Denúncia / Rejeitar" />
        </Route>
        <Route path={`${path}/status/:status/show/:id/done`}>
          <Done title="Petis - Parceiros / Denúncias de maus tratos / Denúncia / Concluir" />
        </Route>
        <Route path={`${path}/status/:status/show/:id/open-osm`}>
          <OpenOsm title="Petis - Parceiros / Denúncias de maus tratos / Denúncia / Abrir OS-m" />
        </Route>
      </mistreatmentContext.Provider>
    </div>
  )
}

export default MistreatmentsRoutes
